import $ from "jquery";
// JS
console.log("HEY");
import './js/main.js'

//FA
// import "virtual-fontawesome-auto"

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'

// SCSS
import './assets/scss/main.scss'
import './assets/tailwind/main.css'
